import asyncRoute from '../../lib/asyncRoute';

export const MngPg01 = asyncRoute(() => import('./MngDashController'));
export const MngPg02 = asyncRoute(() => import('./MngRankController'));
export const MngPg03 = asyncRoute(() => import('./MngMemberController'));
export const MngPg04 = asyncRoute(() => import('./MngNotiController'));
export const MngPg05 = asyncRoute(() => import('./MngChatController'));
export const MngPg06 = asyncRoute(() => import('./MngSettingController'));
export const MngPg07 = asyncRoute(() => import('./MngExerciseController'));
